export default "/_next/static/fonts/72cd851c4440de9566476437c365fb15.eot";